import { Box, BoxProps, Stack, type SvgIconProps } from '@mui/material';
import clsx from 'clsx';
import React, { useMemo } from 'react';

export interface AdviceBoxProps extends BoxProps {
  children?: React.ReactNode;
  icon?: null | React.ReactElement<SvgIconProps>;

  variant: 'info' | 'success';
  size?: 'medium' | 'large';
}

function getBgcolor(variant: AdviceBoxProps['variant']) {
  switch (variant) {
    case 'info':
      return 'advice.info';
    case 'success':
      return 'advice.success';
    default:
      return 'advice.info';
  }
}

export const AdviceBox: React.FC<AdviceBoxProps> = ({ children, variant, icon, size = 'large', ...props }) => {
  // TODO: This should be a theme really
  const borderRadius = useMemo(() => ({ xs: '5px', lg: '12px' }), []);
  const boxPadding = useMemo(() => (size === 'large' ? { xs: 8, lg: 10 } : { xs: 5, lg: 6 }), [size]);
  const outerStackSpacing = useMemo(() => (size === 'large' ? { xs: 5, lg: 8 } : { xs: 4, md: 6 }), [size]);
  const iconFont = useMemo(() => (size == 'large' ? { xs: '18px', lg: '36px' } : { xs: '18px', lg: '24px' }), [size]);
  const innerStackSpacing = useMemo(() => ({ xs: 5, lg: 6 }), []);

  return (
    <Box
      bgcolor={getBgcolor(variant)}
      borderRadius={borderRadius}
      p={boxPadding}
      className={clsx('PortalsAdviceBox-root')}
      {...props}
    >
      <Stack direction="row" spacing={outerStackSpacing}>
        {icon && <Box fontSize={iconFont}>{React.cloneElement(icon, { fontSize: 'inherit' })}</Box>}
        <Stack direction="column" spacing={innerStackSpacing} flexGrow={1}>
          {children}
        </Stack>
      </Stack>
    </Box>
  );
};
